interface Props { onSnooze: () => void }

export default function CutoffOverlay({ onSnooze }: Props) {
  return (
    <div className="cutoff-bar">
      Wrap up — Claire's winding down.
      <button type="button" onClick={onSnooze}>Snooze 30 min</button>
    </div>
  )
}
